<template>
    <div class="fechas">
        <div><i class="fas fa-play start-icon"></i> <span class="text-xs">{{ startDate }}</span></div>
        <div><i class="fas fa-flag-checkered end-icon"></i> <span class="text-xs">{{ finishDate }}</span></div>
    </div>
</template>

<script>
export default {
    props: {
        startDate: String,
        finishDate: String
    }
}
</script>

<style>
.fechas {
  font-size: 10px;
  color: #4B5563; /* text-gray-600 */
}

.start-icon {
  color: green;
  margin-right: 4px;
}

.end-icon {
  color: red;
  margin-right: 4px;
}
</style>